// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__zdXiN","item":"PaymentsMobile_item__2GtVD","label":"PaymentsMobile_label__aj5zB","amount":"PaymentsMobile_amount__2wASJ"};